import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { patchMusicLink } from 'redux/music-links/actions';

import CommonLinkContainer
  from 'components/common/link-elements/CommonLinkContainer';
import MusicLinkItemHeaderContent
  from 'components/dashboard/music-links-content/MusicLinkItemHeaderContent';
import MusicLinkItemExpandedContent
  from 'components/dashboard/music-links-content/MusicLinkItemExpandedContent';

import './MusicLinkItem.css';

function MusicLinkItem(props) {
  const {
    patchMusicLink,
    musicLinkItem,
    patchMusicLinkError,
  } = props;

  return (
    <div className="dashboard-music-link-item__component">
      <CommonLinkContainer
        linkItem={musicLinkItem}
        patchLinkFunction={patchMusicLink}
        allowExpand
        headerContent={
          <MusicLinkItemHeaderContent
            key={`music-link-item-header-content-key-${musicLinkItem.id}`}
            item={musicLinkItem}
            patchMusicLinkError={patchMusicLinkError}
          />
        }
        expandedContent={
          <MusicLinkItemExpandedContent
            key={`music-link-item-expanded-content-key-${musicLinkItem.id}`}
            item={musicLinkItem}
          />
        }
      />
    </div>
  );
};

MusicLinkItem.propTypes = {
  patchMusicLink: PropTypes.func.isRequired,
  musicLinkItem: PropTypes.object.isRequired,
  patchMusicLinkError: PropTypes.object,
  musicServices: PropTypes.object,
};

MusicLinkItem.defaultProps = {
  musicLinkItem: null,
  patchMusicLinkError: null,
  musicServices: null,
};

export default connect(
  null,
  {
    patchMusicLink,
  },
)(MusicLinkItem);
